import { EDIT_USER_PROFILE, GET_LEADERS, GET_USER_PROFILE } from '../actionTypes/UserActionType';

const INIT_STATE = {
  userData: {},
  userList: [],
};

const userReducer = (state = INIT_STATE, action) => {
  switch (action.type) {
    case GET_LEADERS: {
      return { ...state, leaderList: action.payload };
    }
    case GET_USER_PROFILE: {
      return { ...state, userData: action.payload };
    }
    // case SAVE_USER_PROFILE: {
    //   const _userData = addData(state.userData, action.payload)
    //   return { ...state, userData: _userData }
    // }
    // case DELETE_USER_PROFILE: {
    //   const _userData = deleteById(state.userData, action.payload)
    //   return { ...state, userData: _userData }
    // }
    case EDIT_USER_PROFILE: {
      const _userData = action.payload;
      return { ...state, userData: _userData };
    }

    default:
      return state;
  }
};

export default userReducer;
